module.exports = __webpack_public_path__ + "static/04-collaboration-small-c6a02116e187fd7a1a70292e8d25dd14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/homepage/04-collaboration-small.jpg
// module id = 2643
// module chunks = 35783957827783